import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Brain } from 'lucide-react';

const AIAndML = () => {
  const features = [
    {
      title: 'Predictive Analytics',
      description: 'Machine learning models that forecast trends and optimize decision-making'
    },
    {
      title: 'Natural Language Processing',
      description: 'Advanced NLP solutions for text analysis, chatbots, and sentiment analysis'
    },
    {
      title: 'Computer Vision',
      description: 'Image recognition, object detection, and visual AI applications'
    },
    {
      title: 'Deep Learning',
      description: 'Neural networks for complex pattern recognition and automation'
    },
    {
      title: 'AI Integration',
      description: 'Seamless integration of AI capabilities into existing systems'
    },
    {
      title: 'Custom ML Models',
      description: 'Tailored machine learning solutions for your specific use case'
    }
  ];

  const benefits = [
    {
      title: 'Cutting-Edge Technology',
      description: 'Leverage the latest AI frameworks like TensorFlow, PyTorch, and OpenAI'
    },
    {
      title: 'Scalable Solutions',
      description: 'AI systems designed to grow with your business needs'
    },
    {
      title: 'Data-Driven Insights',
      description: 'Transform raw data into actionable intelligence'
    },
    {
      title: 'Continuous Learning',
      description: 'Models that improve over time with new data'
    }
  ];

  const pricing = [
    {
      id: 1,
      name: 'AI Starter',
      price: '$5,000',
      period: 'project',
      description: 'Perfect for testing AI capabilities',
      features: [
        'Simple ML model development',
        'Data preprocessing',
        'Model training & testing',
        'Basic deployment',
        '1 month support'
      ]
    },
    {
      id: 2,
      name: 'AI Professional',
      price: '$15,000',
      period: 'project',
      popular: true,
      description: 'Advanced AI solutions for businesses',
      features: [
        'Custom AI model development',
        'Advanced NLP/Computer Vision',
        'API integration',
        'Cloud deployment',
        'Performance monitoring',
        '3 months support'
      ]
    },
    {
      id: 3,
      name: 'AI Enterprise',
      price: 'Custom',
      description: 'Full-scale AI transformation',
      features: [
        'Enterprise AI strategy',
        'Multiple AI solutions',
        'Custom neural networks',
        'Scalable infrastructure',
        'Ongoing optimization',
        'Dedicated AI team',
        '12 months support'
      ]
    }
  ];

  return (
    <ServicePageTemplate
      title="AI & ML Solutions"
      subtitle="Intelligent AI & Machine Learning"
      description="Transform your business with cutting-edge artificial intelligence and machine learning solutions that automate processes, provide insights, and drive innovation."
      icon={Brain}
      features={features}
      benefits={benefits}
      pricing={pricing}
      color="#d987ff"
    />
  );
};

export default AIAndML;
